/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-30 11:57:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-15 18:52:18
 * @FilePath: /src/app/payment/components/OrderSummary/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE+
 */
import { IPrice } from '@/api/types/order';

import { Address } from '@/api/types/public';
import { IUseWallet } from '@/app/(payment)/payment/ClientPage';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { PAY_TYPE_MAP } from '@/utils/constants';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { getShippingMethodText } from '@/utils/shipping';
import { accSub, add, isEmpty } from '@/utils/tools';
import { useMediaQuery } from '@mui/material';
import { useEffect, useImperativeHandle, useMemo } from 'react';
import { useTranslations } from 'next-intl';

interface OrderSummaryProps {
  price: IPrice['price'];
  shippingAddress: Address;
  freightList: IPrice['freight'];
  freight: string;
  abShowFreeDelivery: boolean;
  isCheckDelivery: number;
  isUseWallet: IUseWallet;
  walletPayAmount: string;
  payAmountWithWallet: string;
  paymentType: string;
  isRedeem: boolean;
  onGetGrantTotal: (total: number | string) => void;
  ref: any;
}

export default function OrderSummary({ ...props }: OrderSummaryProps) {
  const t = useTranslations('payment.OrderSummary');
  const globalT = useTranslations('');

  const {
    price,
    shippingAddress,
    freightList,
    freight,
    abShowFreeDelivery,
    isCheckDelivery,
    isUseWallet,
    walletPayAmount,
    payAmountWithWallet,
    paymentType,
    isRedeem,
    onGetGrantTotal,
    ref,
  } = props;
  const currency = useStore((state) => state.currency);
  const publicResourceData = useStore((state) => state.publicResourceData);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const getMethodPrice = useMemo(() => {
    let _price: string;
    if (freight && freightList.find((item) => item.name === freight)) {
      _price = freightList
        .find((item) => item.name === freight)
        // @ts-ignore: Freight item structure not fully typed
        .origin_price_info.find((item) => item.currency === currency.name).price;
    }
    return _price || '0';
  }, [freight, freightList, currency]);

  const freightDisCountPrice = useMemo(() => {
    let discount = 0;
    if (freight && freightList.find((item) => item.name === freight)) {
      discount =
        Number(freightList.find((item) => item.name === freight).freight_discount_price) || 0;
    }
    return discount;
  }, [freight, freightList]);

  const shippingAsTax = useMemo(() => {
    let tax = '';

    if (freight && freightList.find((item) => item.name === freight)) {
      // @ts-ignore: FreightList item structure is not fully typed and tax property may not exist in type definition
      tax = freightList.find((item) => item.name === freight).tax;
    }
    return tax;
  }, [freight, freightList]);

  const worryFreeDelivery = useMemo(() => {
    let discount = '';
    if (freight && freightList.find((item) => item.name === freight)) {
      discount =
        freightList.find((item) => item.name === freight)?.insurance?.insurance_price || '0.00';
    }
    return discount;
  }, [freight, freightList]);

  const GrandTotal = useMemo(() => {
    let tax = '';
    if (Number(shippingAsTax)) {
      tax = shippingAsTax;
    } else if (price.tax) {
      tax = price.tax;
    }

    // 加上物流保险金额
    if (abShowFreeDelivery && isCheckDelivery === 1) {
      tax = add(tax, worryFreeDelivery).toString();
    }

    let total = add(add(getMethodPrice, price.subtotal), tax);
    total = Number(accSub(total, freightDisCountPrice));

    if (isNaN(total)) {
      return '0.00';
    }

    return Number(total).toFixed(2);
  }, [
    getMethodPrice,
    price.subtotal,
    freightDisCountPrice,
    shippingAsTax,
    worryFreeDelivery,
    isCheckDelivery,
    abShowFreeDelivery,
  ]);

  // 使用 useEffect 来调用 onGetGrantTotal，避免在渲染期间调用 setState
  useEffect(() => {
    onGetGrantTotal(GrandTotal);
  }, [GrandTotal, onGetGrantTotal]);

  // 渲染运输方式信息
  const renderShippingMethod = () => {
    const currentFreight = freightList.find((item) => item.name === freight);

    if (currentFreight) {
      return (
        <p className="flex justify-between mb-16">
          <span className="text-14 ">
            {getShippingMethodText(
              currentFreight.name,
              currentFreight.time_min,
              currentFreight.time_max,
              globalT,
            )}
          </span>
          <span className="text-14 font-bs md:font-br">
            {formatPriceNumberWithSymbol(getMethodPrice, currency)}
          </span>
        </p>
      );
    }

    return null;
  };

  const renderShippingMoney = () => {
    const currentFreight: any = freightList.find((item) => item.name === freight);

    const priceinfo = () => {
      return (
        <span className="text-14 font-bs md:font-br">
          -{formatPriceNumberWithSymbol(currentFreight.freight_discount_price, currency)}
        </span>
      );
    };

    if (
      currentFreight &&
      currentFreight.freight_discount_type !== 1 &&
      currentFreight.freight_discount_type !== 5
    ) {
      switch (currentFreight.freight_discount_type) {
        case 2:
          return (
            <div className="flex justify-between">
              {t('freeShipping')} ({t('over')}{' '}
              {formatPriceNumberWithSymbol(
                freeThreshold(currentFreight.free_threshold_price_info),
                currency,
              )}
              ){priceinfo()}
            </div>
          );
        case 3:
          return (
            <div className="flex justify-between">
              {t('freeShipping')} (Zing)
              {priceinfo()}
            </div>
          );
        case 4:
          return (
            <div className="flex justify-between">
              {t('shippingCoupon')}
              {priceinfo()}
            </div>
          );
        default:
          return null;
      }
    }
  };

  const freeThreshold = (priceInfo: any) => {
    if (!isEmpty(priceInfo)) {
      const currentPrice = priceInfo.find((item) => item.currency === currency.name);
      return currentPrice.price;
    }
    return '';
  };

  const SDGetPrice = () => {
    const shippingItem = freightList.find(
      (item) =>
        item.name === freight &&
        item.freight_discount_type !== 1 &&
        item.freight_discount_type !== 5,
    );
    return {
      order_amount: parseFloat(price.total),
      shipping_amount: parseFloat(getMethodPrice),
      free_shipping_discount_amount: shippingItem
        ? parseFloat(shippingItem.freight_discount_price)
        : undefined,
      estimated_taxes: shippingAsTax ? parseFloat(shippingAsTax) : parseFloat(price.tax),
      // @ts-ignore: Price object structure varies and point_discount property may not be in type definition
      points_discount_amount: parseFloat(price.point_discount) || 0,
      coupon_discount_amount: parseFloat(price.code_discount) || 0,
      second_halfprice_discount_amount: parseFloat(price.discount) || 0,
      vip_amount: parseFloat(price.vip_price) || 0,
      electronic_wallet_payment_amount: parseFloat(walletPayAmount) || 0,
    };
  };

  // 将改方法暴露出去
  useImperativeHandle(ref, () => ({
    SDGetPrice,
  }));

  if (!price) return null;

  return (
    <div
      className={
        'bg-white rounded-[10px] md:rounded-[5px]  pt-30 md:pt-12 w-full py-[12px] px-[1.5625vw] mb-[12px] md:mb-0 mt-12 md:mt-0 '
      }
    >
      <div className="bg-white rounded-[5px] w-full mb-[12px] ">
        <WebOnly>
          <div className="mb-20 text-left text-lg font-bb">{t('orderSummary')}</div>
        </WebOnly>

        <div className="border-b border-gray-200">
          {/*   商品合计价格  */}
          <div className="flex justify-between mb-16">
            <span className="text-14">{t('subtotal')}</span>
            <span className="text-14 font-bs md:font-br ">
              {formatPriceNumberWithSymbol(price.total, currency)}
            </span>
          </div>

          {/* 第二件半价折扣 */}
          {parseInt(price.discount, 10) > 0 && (
            <div className="flex justify-between mb-16">
              <span className="text-14">
                {
                  // @ts-ignore: 类型定义不完整
                  publicResourceData.config_names.product_content_half_price_member.rule
                    .discount_text
                }{' '}
                {
                  // @ts-ignore: 类型定义不完整
                  publicResourceData.config_names.product_content_half_price_member.rule
                    .discount_rate
                }
                {'% Off'}
              </span>
              <span className="text-14 font-bs md:font-br ">
                -{formatPriceNumberWithSymbol(price.discount, currency)}
              </span>
            </div>
          )}

          {/* 优惠券/优惠码折扣 */}
          {price.code_discount && (
            <div className="flex justify-between mb-16">
              <span className="text-14  ">{t('codeOrCoupon')}</span>
              {Number(price.code_discount) >= 0 ? (
                <span className="text-14 font-bs md:font-br">
                  -{formatPriceNumberWithSymbol(price.code_discount, currency)}
                </span>
              ) : (
                <span className="text-14 font-bs md:font-br ">
                  {/* @ts-ignore: Price object structure varies and code_discount property may not be in type definition */}
                  {formatPriceNumberWithSymbol(Math.abs(price.code_discount), currency)}
                </span>
              )}
            </div>
          )}

          {/* 积分折扣 */}
          {Number(price.is_point) > 0 && (
            <div className="flex justify-between mb-16">
              <span className="text-14  ">
                {t('Redeem')} -{price.expend_point} {t('points')}
              </span>
              <span className="text-14 font-bs md:font-br">
                {/* @ts-ignore: Price object structure varies and point_discount property may not be in type definition */}
                -{formatPriceNumberWithSymbol(price.point_discount, currency)}
              </span>
            </div>
          )}

          {/*  Zing 会员 */}
          {price.vip_price && (
            <div className="flex justify-between mb-16">
              <span className="text-14  ">{t('zingMemberOneYear')}</span>
              <span className="text-14 font-bs md:font-br">
                {formatPriceNumberWithSymbol(price.vip_price, currency)}
              </span>
            </div>
          )}

          {/* 运费 */}
          {shippingAddress?.id && <div>{renderShippingMethod()}</div>}

          {/* 运费优惠 */}
          {shippingAddress?.id && <div className="mb-16 text-14">{renderShippingMoney()}</div>}

          {/* 消费税  */}
          {(!!Number(price.tax) || !!Number(shippingAsTax)) && (
            <div className="flex justify-between mb-16 text-14">
              {/* @ts-ignore: Price object structure varies and tax_name property may not be in type definition */}
              <span className="text-14 ">{price.tax_name || 'Estimated Taxes'}</span>
              {shippingAsTax && (
                <span className="text-14 font-bs md:font-br">
                  {formatPriceNumberWithSymbol(shippingAsTax, currency)}
                </span>
              )}
              {!shippingAsTax && (
                <span className="text-14 font-bs md:font-br">
                  {formatPriceNumberWithSymbol(price.tax, currency)}
                </span>
              )}
            </div>
          )}

          {/* //TODO: 物流保险 */}
          {abShowFreeDelivery && isCheckDelivery === 1 && +worryFreeDelivery > 0 && (
            <div className=" flex justify-between mb-16 text-14">
              <span className="text-14 ">{t('worryFreeDelivery')}</span>
              <span className="text-14 font-bs md:font-br">
                {formatPriceNumberWithSymbol(worryFreeDelivery, currency)}
              </span>
            </div>
          )}
        </div>

        {/* 总价 */}
        <div className="flex justify-between mt-26 md:mt-16 text-14 md:text-18 md:font-bb">
          <span>{t('grandTotal')}</span>
          <span className="md:text-[22px] text-[20px] font-bb">
            {formatPriceNumberWithSymbol(GrandTotal, currency)}
          </span>
        </div>

        {isUseWallet === IUseWallet.USE && (
          <div className="w-full flex justify-end">
            <div
              className="bg-[#f5f6f7] rounded-[8px] p-8 relative mt-10 text-13  w-7/10 md:w-4/5
              before:content-[''] before:absolute before:-top-[10px] before:right-[20px]
              before:border-l-[10px] before:border-r-[10px] before:border-b-[10px]
              before:border-l-transparent before:border-r-transparent before:border-b-[#f5f6f7]"
            >
              {Number(walletPayAmount) > 0 && (
                <div className="flex justify-between  text-12 md:text-14 ">
                  <span>{t('storeCredit')}</span>
                  <span>{formatPriceNumberWithSymbol(walletPayAmount, currency)}</span>
                </div>
              )}
              {Number(payAmountWithWallet) > 0 && paymentType && (
                <div className="flex justify-between  mt-16 text-12 md:text-14 ">
                  <span>{PAY_TYPE_MAP[paymentType]}</span>
                  <span>{formatPriceNumberWithSymbol(payAmountWithWallet, currency)}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* 普通订单并且是会员时展示获取积分文案 */}
        {!isRedeem && price.gain_point > 0 && (
          <div className="gain-point notranslate text-12 md:text-14 md:mt-10 mt-12 text-right">
            {t.rich('earnPointsFromThisOrder', {
              points: price.gain_point,
              pointText: price.gain_point > 1 ? t('points') : t('point'),
              b: (chunks) => <span className="text-warning">{chunks}</span>,
            })}
          </div>
        )}
        {isRedeem && (
          <div className={`text-14 mt-10 ${isMobile ? 'text-left' : 'text-right'}`}>
            {t('noPointsForRewardsStore')}
          </div>
        )}
      </div>
    </div>
  );
}
